import { clamp, easeOutCubic, glow, mulberry32, TAU, type DrawFn } from '../lib/math'

export function createMercury(): DrawFn {
  const rng = mulberry32(28)
  const drops = Array.from({ length: 9 }, (_, i) => ({
    a: rng() * TAU,
    r: 70 + rng() * 80,
    s: 5 + rng() * 11,
    speed: 0.22 + rng() * 0.4,
    phase: rng() * TAU,
    delay: i * 0.07,
  }))

  return (ctx, t, w, h) => {
    const cx = w * 0.5
    const cy = h * 0.4
    ctx.clearRect(0, 0, w, h)
    const intro = easeOutCubic(clamp(t / 1.3))

    ctx.globalCompositeOperation = 'lighter'
    const hx = cx + Math.cos(t * 0.7) * 22
    const hy = cy - 24 + Math.sin(t * 0.9) * 10
    glow(ctx, hx, hy, 26, `rgba(255,255,255,${0.22 * intro})`)

    for (const d of drops) {
      const appear = easeOutCubic(clamp((t - d.delay) / 0.8))
      const ang = d.a + t * d.speed
      const wobble = Math.sin(t * 1.4 + d.phase) * 8
      const x = cx + Math.cos(ang) * (d.r + wobble) * intro
      const y = cy + Math.sin(ang) * (d.r * 0.62 + wobble) * intro
      const r = d.s * appear
      const g = ctx.createRadialGradient(x - r * 0.3, y - r * 0.35, 0, x, y, r)
      g.addColorStop(0, `rgba(255,255,255,${0.8 * appear})`)
      g.addColorStop(0.4, `rgba(190,205,220,${0.35 * appear})`)
      g.addColorStop(1, 'rgba(40,50,60,0)')
      ctx.fillStyle = g
      ctx.beginPath()
      ctx.arc(x, y, r, 0, TAU)
      ctx.fill()
    }

    for (let i = 0; i < 3; i++) {
      const u = (t * 0.32 + i / 3) % 1
      ctx.strokeStyle = `rgba(200,220,240,${(1 - u) * 0.16 * intro})`
      ctx.lineWidth = 1
      ctx.beginPath()
      ctx.ellipse(cx, cy, (86 + u * 70) * intro, (52 + u * 42) * intro, 0, 0, TAU)
      ctx.stroke()
    }

    ctx.globalCompositeOperation = 'source-over'
  }
}
